import { FC } from 'react';

// Quarks
import Flex from 'quarks/Flex';

import ChecklistCard from 'components/Cards/ChecklistCard';

import type { ContentfulComponentCardDeck } from 'graphqlTypes';

interface ComponentCardDeckProps extends ContentfulComponentCardDeck {
  backgroundIsDark?: boolean;
}

const ChecklistCardDeck: FC<ComponentCardDeckProps> = ({ card, backgroundIsDark, ...props }) => (
  <Flex flexDirection="column" gap="24px" marginAll="auto" {...props}>
    <Flex flexDirection="column" gap="16px" width="100%">
      {card && (
        <Flex
          gap="30px"
          className="card"
          justifyContent="center"
          xs={{ flexDirection: 'column' }}
          md={{ flexDirection: 'row' }}
        >
          {card.map(cardData => (
            <Flex key={cardData?.id} width="100%" maxWidth="100%" md={{ maxWidth: '470px' }}>
              <ChecklistCard backgroundIsDark={backgroundIsDark} {...cardData} />
            </Flex>
          ))}
        </Flex>
      )}
    </Flex>
  </Flex>
);

export default ChecklistCardDeck;
